if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.mount();
		}

		mount(){

			/* -- > DRAWERS < -- */

			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('inert-inside') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

			// Sticky header

			if ( this.hasAttribute('data-sticky-header') ) {

				const stickyHeader = document.createElement('div');
				stickyHeader.classList = 'sticky-header'
				stickyHeader.innerHTML = `<div class="header__bottom header-container container--large portable-hide">
					${this.querySelector('.header__bottom').innerHTML}
				</div>
				<div class="site-header header__top container--large">
					${this.querySelector('.header__top').innerHTML}
				</div>`;
				document.body.append(stickyHeader);

				stickyHeader.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-sticky`;
				})

				window.lst = window.scrollY;
				window.lhp = 0;

				const stickyHeaderDeskBound = this.querySelector('.header__bottom');
				const stickyHeaderMobileBound = this.querySelector('.header__top');

				this.SCROLL_StickyHelper = () =>{
					
					var st = window.scrollY;
					if ( ( st <= 0 || ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top >= 0 : stickyHeaderMobileBound.getBoundingClientRect().top >= 0 ) ) && stickyHeader.classList.contains('show') ) {
						stickyHeader.classList.remove('show');
						return;
					}

					if ( st < 0 || Math.abs(lst - st) <= 5 )
						return;	

					if ( st > window.lhp ) {

						if ( st == 0 && stickyHeader.classList.contains('show') ) {

							stickyHeader.classList.remove('show');

						} else if ( st <= lst && ! stickyHeader.classList.contains('show') ) {

							window.lhp = stickyHeader.offsetTop;
							if ( ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top : stickyHeaderMobileBound.getBoundingClientRect().top ) < -100 ) {
								stickyHeader.classList.add('show');
							}

						} else if ( st > lst && stickyHeader.classList.contains('show') ) {
							stickyHeader.classList.remove('show');
						}

					} 

					window.lst = st;

				}

				window.addEventListener('scroll', this.SCROLL_StickyHelper, {passive:true});

				/* The sticky clone's .submenu-masonry used to be laid out by Macy here.
				   Macy is gone — assets/tlh-header.css lays the mega menu out with CSS
				   grid, and those selectors are scoped to `.header__bottom`, which the
				   clone carries, so the clone is styled without any JS.

				   NB the old guard was `if ( Macy )` on a bare identifier, which THROWS
				   a ReferenceError when the script is absent rather than evaluating
				   false. That aborted mount() before the [data-js-sidebar-handle]
				   bindings below, killing the hamburger and the cart drawer. Even
				   before Macy was removed this was live: snippets/site-nav.liquid only
				   loaded vendor-macy.js when a mega menu existed, so any menu without
				   one hit the same throw. Use `typeof x !== 'undefined'` for guards
				   like this. */

			}

			// drawer cart connections

			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elm.setAttribute('aria-expanded', 'true');
						elmSidebar.show();
					})
					elm.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							elm.setAttribute('aria-expanded', 'true');
							elmSidebar.show();
							elmSidebar.querySelector('[data-js-close]').focus();
						}
					})
				}
			})
			
			// closing drawers

			document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( e.target.closest('.sidebar').classList.contains('sidebar--opened') ) {
						e.target.closest('.sidebar').hide();
					}
				});
			});
			document.querySelector('.site-overlay').addEventListener('click', ()=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
				}
			});

			// resizing drawers

			const rootHeight = document.getElementById('root-height');
			this.RESIZE_SidebarHelper = debounce(()=>{
				rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
				}`;
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
			}`;

			// Init modal windows

			document.querySelectorAll('[aria-controls="modal-store-selector"]').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
					if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
						document.getElementById(elm.getAttribute('aria-controls')).show();
					}
				})
				elm.addEventListener('keyup', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					}
				})
			});

			// Submenu alignment

			const rtl = document.documentElement.getAttribute('dir') == 'rtl';
			document.querySelectorAll('.site-nav.style--classic .has-submenu').forEach(elm=>{
				elm.addEventListener('mouseover', ()=>{
					if ( elm.querySelector('.normal-menu') ) {
						elm.querySelector('.normal-menu').style.left = `${rtl ? elm.getBoundingClientRect().right : elm.getBoundingClientRect().left}px`;
					}
				})
			})

			// predictive search

			if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {
				document.querySelectorAll('search-form [data-js-search-input]').forEach(elm=>{
					elm.addEventListener('focus', ()=>{
						document.getElementById(elm.dataset.jsFocusOverlay).classList.add('active');
						if ( ! document.body.classList.contains('predictive-script-loaded') ) {
							document.body.classList.add('predictive-script-loaded')
							const predictiveSearchJS = document.createElement('script');
							predictiveSearchJS.src = KROWN.settings.predictive_search_script;
							document.head.appendChild(predictiveSearchJS); 
						}
					})
					elm.addEventListener('keydown', e=>{
						if ( e.keyCode == window.KEYCODES.TAB ) {
							if ( document.getElementById('search-results-overlay-desktop').classList.contains('active') ) {
								document.getElementById('search-results-overlay-desktop').classList.remove('active');
							}
						}
					})
				})
				window.addEventListener('load', ()=>{
					document.querySelectorAll('.search-results-overlay').forEach(elm=>{
						elm.style = '';
					})
				});
			} else {
				document.querySelector('search-form [data-js-search-input] + button').classList.add('button--invisibile-trigger');
			}

			// touch navigation for the menu

			const closeTouchSubmenus = (focusedElm, focusedParent=null)=>{
				document.querySelectorAll('.style--classic li.focus').forEach(elm=>{
					if ( ! ( elm === focusedElm || elm === focusedParent ) ) {
						elm.classList.remove('focus');
					}
				})
			}
			let babyMenuTouch = false;
			document.querySelectorAll('.style--classic .has-babymenu').forEach(elm=>{
				elm.addEventListener('touchstart', e=>{
					elm.firstElementChild.style.pointerEvents = 'none';
					elm.classList.toggle('focus');
					babyMenuTouch = true;
					closeTouchSubmenus(elm,elm.closest('.has-submenu'));
				})
			})
			document.querySelectorAll('.style--classic .has-submenu').forEach(elm=>{
				if ( ! elm.classList.contains('mega-link') ) {
					elm.addEventListener('touchstart', e=>{
					elm.firstElementChild.style.pointerEvents = 'none';
					if ( ! babyMenuTouch ) {
						elm.classList.toggle('focus');
						closeTouchSubmenus(elm);
					}
						babyMenuTouch = false;
					})
				}
			})

			// tab navigation for the menu

			document.querySelectorAll('.site-nav.style--classic .has-submenu > a').forEach(childEl=>{

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{

					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else if ( document.activeElement.parentNode.classList.contains('has-submenu') && elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'true');
						}
					}
				});	
				
				if ( elm.querySelector('.submenu-holder > li:last-child a') ) {
					elm.querySelector('.submenu-holder > li:last-child a').addEventListener('focusout', e=>{
						if ( elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					});
				}

			});

			document.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a').forEach(childEl=>{	

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					}
				});

				if ( elm.querySelector('.babymenu li:last-child a') ) {
					elm.querySelector('.babymenu li:last-child a').addEventListener('focusout', e=>{
						if ( elm.parentNode.classList.contains('focus') ) {
							elm.parentNode.classList.remove('focus');
							elm.parentNode.setAttribute('aria-expanded', 'false');
						}
					});
				}

			})

		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
		}

	}
	
  if ( typeof customElements.get('main-header') == 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			this.querySelector('[data-js-close]').addEventListener('click', ()=>{
				this.hide();
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
					if ( openedSidebar ){
						openedSidebar.hide();
					}
				}
			});
		}

		/* 
			* generic hide/show functions 
		*/

		show(){

			this.opened = true;
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			this.style.display = 'grid';
			setTimeout(()=>{
				this.classList.add('sidebar--opened');
				window.inertElems.forEach(elm=>{
					elm.setAttribute('inert', '');
				})
			}, 15);
			if ( this.id == "site-cart-sidebar" ) {
				if ( document.querySelector('#cart-recommendations css-slider') ) {
					document.querySelector('#cart-recommendations css-slider').resetSlider();
				}
			}

		}

		hide(){

			this.opened = false;
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			})

			document.querySelector(`[aria-controls="${this.id}"]`).setAttribute('aria-expanded', 'false');

			setTimeout(()=>{
				this.style.display = 'none';
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') == 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof MobileNavigation !== 'function' ) {
		
	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;

			this.querySelectorAll('.has-submenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = true;
						this.classList.add('opened-first-submenu');
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.has-babymenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = true;
						this.classList.add('opened-second-submenu');
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.submenu-back a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = false;
						this.classList.remove('opened-second-submenu');
						this._resizeContainer();
					} else if ( this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = false;
						this.classList.remove('opened-first-submenu');
						this._resizeContainer(true);
					}
					this.closest('sidebar-drawer').scrollTo({top: 0});
					setTimeout(()=>{
						e.target.closest('li.opened').classList.remove('opened');
					}, 301);
					e.preventDefault();
				})
			});

			if ( this.dataset.showHeaderActions == 'true' ) {

				const mobileNavActions = document.createElement('div');
				mobileNavActions.classList = "header-actions flex-buttons";
				mobileNavActions.innerHTML = document.querySelector('[data-js-header-actions]').innerHTML;
				this.querySelector('nav').prepend(mobileNavActions);

				mobileNavActions.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-mobile`;
				});
				
				mobileNavActions.querySelectorAll('[data-modal]').forEach(elm=>{
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					})
				});
				
			}

		}

		_resizeContainer(main=false){
      if ( main ) {
				this.style.height = `auto`;
      } else {
				if ( this._openedSecondSubmenu ) {
					this.style.height = `${this.querySelector('.has-babymenu.opened .babymenu').scrollHeight}px`;
				} else if ( this._openedFirstSubmenu ) {
					this.style.height = `${this.querySelector('.has-submenu.opened .submenu').scrollHeight}px`;
				}  
      }
		}

	}

  if ( typeof customElements.get('mobile-navigation') == 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}

}

if ( typeof ScrollableNavigation !== 'function' ) {

	class ScrollableNavigation extends HTMLElement {

		constructor() {

			super();

			this.linkList = this.querySelector('.link-list');
			this.header = this.parentNode;
			window.addEventListener('resize', debounce(()=>{
				this.checkNav();
			}, 200));
			this.checkNav();

			const rtl = document.documentElement.getAttribute('dir') == 'rtl';

			this.parentNode.querySelector('.scrollable-navigation-button--left').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft - (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})
			this.parentNode.querySelector('.scrollable-navigation-button--right').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft + (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})

		}

		checkNav() {
			if ( this.linkList.scrollWidth > this.offsetWidth ) {
				this.header.classList.add('scrolling-navigation-enabled');
			} else {
				this.header.classList.remove('scrolling-navigation-enabled');
			}
		}
		
	}

  if ( typeof customElements.get('scrollable-navigation') == 'undefined' ) {
		customElements.define('scrollable-navigation', ScrollableNavigation);
	}

}

/* ======================================================================
   MEGA MENU PRODUCT IMAGES
   Loads product images for menu items
   ====================================================================== */
(function loadMegaMenuProductImages() {

  // Shopify CDN sizing. The previous code did
  //     url.replace('.jpg', '_80x80_crop_center.jpg')
  // which silently no-ops on .jpeg / .png / .webp and then dropped a full-size
  // image into a 64px box. Query params work for every format and coexist with
  // the ?v= cache-buster the CDN already appends.
  function sizedImage(url, px) {
    if (!url) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') +
      'width=' + px + '&height=' + px + '&crop=center';
  }

  // Mirrors _formatMoney in assets/component-product-form.js:361 so menu prices
  // follow the shop's own currency format instead of a hardcoded '$'.
  // KROWN.settings.shop_money_format is set in layout/theme.liquid:216.
  function formatMoney(cents) {
    var format = (window.KROWN && window.KROWN.settings && window.KROWN.settings.shop_money_format) || '${{amount}}';
    var placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!placeholder) return format;

    function withDelimiters(precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(cents) || cents === null) return '0';
      var parts = (cents / 100.0).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    var value;
    switch (placeholder[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(0); break;
      case 'amount_with_comma_separator':
        value = withDelimiters(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(0, '.', ','); break;
      case 'amount_with_space_separator':
        value = withDelimiters(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(0, ' ', ','); break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(2, "'", '.'); break;
      default:
        value = withDelimiters(2); break;
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  // Which export frame a product's photos were shot to -- the JS twin of
  // snippets/tlh-pouch-frame.liquid, kept in step with it. The mega menu builds
  // its tiles from the product JSON rather than Liquid, so the handle list has
  // to exist here too. assets/tlh-pouch-frame.css carries the geometry.
  var MEGA_POUCH_TALL  = ['salted-lentil-snack', 'spicy-lentil-snack'];
  var MEGA_POUCH_SHORT = ['salted-lotus-seeds', 'popped-water-lily-seeds-cheddar-cheese', 'popped-water-lily-seeds-tangy-tomato'];
  function megaPouchFrame(handle) {
    if (MEGA_POUCH_TALL.indexOf(handle)  !== -1) return ' menu-product-image--pouch-tall';
    if (MEGA_POUCH_SHORT.indexOf(handle) !== -1) return ' menu-product-image--pouch-short';
    return '';
  }

  function addProductImages() {
    var productLinks = document.querySelectorAll('.site-nav.style--classic .submenu.mega-menu .babymenu .menu-link');

    productLinks.forEach(function(link) {
      if (link.querySelector('.menu-product-image')) return;

      var href = link.getAttribute('href');
      if (!href || href.indexOf('#') !== -1) return;

      var productMatch = href.match(/\/products\/([^/?]+)/);
      if (!productMatch) return;

      var productHandle = productMatch[1];

      var imageContainer = document.createElement('span');
      imageContainer.className = 'menu-product-image' + megaPouchFrame(productHandle);
      imageContainer.innerHTML = '<span class="menu-product-image-loader"></span>';

      link.insertBefore(imageContainer, link.firstChild);

      fetch('/products/' + productHandle + '.js')
        .then(function(response) { return response.json(); })
        .then(function(product) {
          if (product.featured_image) {
            var img = document.createElement('img');
            // The tile is 64px (tlh-header.css) and 128 was 2x for it -- but a
            // pouch-frame product is scaled to 1.45 on top of that, and 128 left
            // the bag visibly soft on a retina screen. 256 covers both cases and
            // costs nothing on the seven mixes, whose masters cap out below it.
            img.src = sizedImage(product.featured_image, 256);
            img.alt = product.title;
            img.loading = 'lazy';

            imageContainer.innerHTML = '';
            imageContainer.appendChild(img);
          } else {
            imageContainer.remove();
          }

          // Add "Add to Cart" button if product has variants
          if (product.variants && product.variants.length > 0 && !link.querySelector('.menu-add-to-cart')) {
            // Add price display
            if (!link.querySelector('.menu-product-price')) {
              var priceElement = document.createElement('span');
              priceElement.className = 'menu-product-price';
              priceElement.innerHTML = formatMoney(product.variants[0].price);
              link.appendChild(priceElement);
            }

            // Add cart button
            var addToCartBtn = document.createElement('button');
            addToCartBtn.className = 'menu-add-to-cart';
            addToCartBtn.setAttribute('data-variant-id', product.variants[0].id);
            addToCartBtn.setAttribute('data-product-title', product.title);
            addToCartBtn.setAttribute('type', 'button');
            addToCartBtn.setAttribute('aria-label', 'Add ' + product.title + ' to cart');
            addToCartBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1h2l.4 2m0 0L5 11h8l2-7H3.4z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="6" cy="14" r="1" fill="currentColor"/><circle cx="12" cy="14" r="1" fill="currentColor"/></svg><span class="menu-add-to-cart-tooltip">Add to cart</span>';
            link.appendChild(addToCartBtn);
          }
        })
        .catch(function() {
          imageContainer.remove();
        });
    });
  }

  // Deferred loading. This used to run on DOMContentLoaded, firing one fetch
  // per product link before the user had opened anything — N requests on every
  // page of the site. Hold off until a mega-menu item is first hovered or
  // focused, then load once.
  var loaded = false;
  function loadOnce() {
    if (loaded) return;
    loaded = true;
    addProductImages();
  }

  function bindTriggers() {
    var items = document.querySelectorAll('.site-nav.style--classic .submenu-is-mega-menu, .site-nav.style--classic .has-submenu');
    items.forEach(function(item) {
      if (item.getAttribute('data-mega-images-bound')) return;
      item.setAttribute('data-mega-images-bound', '1');
      item.addEventListener('mouseenter', loadOnce);
      item.addEventListener('focusin', loadOnce);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindTriggers);
  } else {
    bindTriggers();
  }

  // section-header.js clones the header into the sticky bar, so new .submenu
  // nodes appear after load. Re-bind them, and populate them too if the images
  // have already been fetched once.
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && node.classList && node.classList.contains('submenu')) {
          setTimeout(function() {
            bindTriggers();
            if (loaded) addProductImages();
          }, 50);
        }
      });
    });
  });

  var siteNav = document.querySelector('.site-nav');
  if (siteNav) {
    observer.observe(siteNav, { childList: true, subtree: true });
  }
})();

/* ======================================================================
   MEGA MENU ADD TO CART FUNCTIONALITY
   ====================================================================== */
(function initMegaMenuAddToCart() {
  function handleAddToCart(event) {
    var button = event.target.closest('.menu-add-to-cart');
    if (!button) return;

    // Prevent link navigation
    event.preventDefault();
    event.stopPropagation();

    // Get variant ID and product info
    var variantId = button.getAttribute('data-variant-id');
    var productTitle = button.getAttribute('data-product-title');

    if (!variantId) return;

    // Add loading state
    button.classList.add('adding');
    var originalHTML = button.innerHTML;
    button.innerHTML = '<span class="menu-product-image-loader"></span>';

    // Add to cart using Shopify Cart API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }]
      })
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      // Restore button
      button.classList.remove('adding');
      button.innerHTML = originalHTML;

      // /cart/add.js answers 4xx with a JSON body instead of throwing, so a
      // sold-out variant would otherwise report "Added to cart".
      if (data && data.status && data.status !== 200) {
        showCartNotification(
          typeof data.description === 'string' ? data.description : 'Unable to add to cart',
          'error'
        );
        return;
      }

      showCartNotification('Added to cart: ' + productTitle, 'success');

      // The drawer's line items are server-rendered once, at page load, so
      // bumping only the header count leaves it stuck on whatever the cart
      // held then — an empty cart still reads "your cart is empty" while the
      // count says 1. refreshCart (assets/component-cart.js) re-fetches the
      // helper-cart section, swaps in the items and subtotal, syncs the
      // header count/total, and opens the drawer.
      if (typeof window.refreshCart === 'function') {
        window.refreshCart();
      } else {
        updateCartCount();
      }
    })
    .catch(function(error) {
      // Error - restore button
      button.classList.remove('adding');
      button.innerHTML = originalHTML;
      showCartNotification('Unable to add to cart', 'error');
    });
  }

  function showCartNotification(message, type) {
    // Check if notification already exists
    var existing = document.querySelector('.menu-cart-notification');
    if (existing) {
      existing.remove();
    }

    var notification = document.createElement('div');
    notification.className = 'menu-cart-notification menu-cart-notification--' + type;
    notification.textContent = message;
    document.body.appendChild(notification);

    // Trigger animation
    setTimeout(function() {
      notification.classList.add('show');
    }, 10);

    // Remove after 3 seconds
    setTimeout(function() {
      notification.classList.remove('show');
      setTimeout(function() {
        notification.remove();
      }, 300);
    }, 3000);
  }

  function updateCartCount() {
    // Fetch current cart to update count
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var cartCount = cart.item_count;

        // Update all cart count elements
        var cartCountElements = document.querySelectorAll('[data-header-cart-count], .cart-count-bubble, #cart-icon-bubble');
        cartCountElements.forEach(function(el) {
          el.textContent = cartCount;
          if (cartCount > 0) {
            el.style.display = '';
          }
        });
      })
      .catch(function() {
        // Silently fail
      });
  }

  // Attach event listener using event delegation
  document.addEventListener('click', handleAddToCart);
})();